export default __webpack_public_path__ + "static/mobile_sizzle-126b84e78ea8f5837f944f9301612421.mp4";